class HeroGift {
  constructor(wrapper) {
    this.wrapper = wrapper;
    this.scene = wrapper.querySelector('.gift-scene');
    this.button = wrapper.querySelector('.open-gift-button');
    this.isOpen = false;

    this.init();
  }

  init() {
    if (!this.scene || !this.button) return;

    this.button.addEventListener('click', () => {
      if (this.isOpen) return;

      this.openGift();
    });
  }

  openGift() {
    this.isOpen = true;

    // Disable button
    this.button.disabled = true;

    // Stop the idle shake
    this.scene.classList.add('stop-shake');

    // Open the gift
    this.scene.classList.add('is-open');

    // Change button text
    this.button.textContent = 'Check Gifts Below';

    // Scroll to collections after lid opens
    setTimeout(() => {
      this.scrollToCollections();
    }, 1500);
  }

  scrollToCollections() {
    const target = document.getElementById('section-template--27116323275032__custom_collection_section_epRQ3z');
    if (!target) return;

    target.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.hero-gift-interaction').forEach(wrapper => {
    new HeroGift(wrapper);
  });
});

// Fade in background media once loaded
document.addEventListener('DOMContentLoaded', () => {
  const bgMedia = document.querySelectorAll('.gift-bg-image, .gift-bg-video');

  bgMedia.forEach(media => {
    if (media.tagName === 'IMG') {
      if (media.complete) {
        media.classList.add('loaded');
      } else {
        media.addEventListener('load', () => media.classList.add('loaded'));
      }
    } else if (media.tagName === 'VIDEO') {
      media.addEventListener('loadeddata', () => media.classList.add('loaded'));
    }
  });
});